import { render, staticRenderFns } from "./PopUpMenu.vue?vue&type=template&id=49c07f2f&scoped=true&"
import script from "./PopUpMenu.vue?vue&type=script&lang=js&"
export * from "./PopUpMenu.vue?vue&type=script&lang=js&"
import style0 from "./PopUpMenu.vue?vue&type=style&index=0&id=49c07f2f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c07f2f",
  null
  
)

export default component.exports